import { Button, Col, Input, Modal, QRCode, Row, Typography } from "antd";
import "./newReportModal.scss";
import React, { useEffect, useState } from "react";
import { HandleErrors } from "../../utils/handleErrors";
import { toast } from "react-toastify";
import { GetReportFilterReq } from "../../interfaces/event.interface";
import { newReportService } from "../../services/report.service";

interface Props {
  show: boolean;
  onClose: () => void;
  filters: GetReportFilterReq
}

export const NewReportModal: React.FC<Props> = (props) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);


  const [name, setName] = useState("");
  const [filters, setFilters] = useState<GetReportFilterReq>({} as GetReportFilterReq );

 

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  useEffect(() => {
    setFilters(props.filters);
  }, [props.filters]);


  const submit = async()=>{
    try {
      setLoading(true)

      const res = await newReportService({
        filters: JSON.stringify(filters),
        name: name
      })

      setName("");
      props.onClose();
      setShow(false)
      toast.success('درخواست دانلود گزارش با موفقیت ثبت شد')
      setLoading(false)
    } catch (error) {
      HandleErrors(error)
      setLoading(false)
    }
  }

  return (
    <div className="NewReportModal">
      <Modal
        destroyOnClose={true}
        title={"دانلود گزارش"}
        onCancel={() => {
          setShow(false);
          props.onClose();
          setName("");
        }}
        open={show}
        footer={null}
        width={550}
      >
        <div className="NewReportModalContent">
          <Row justify={"center"}>
            <Col xs={24} className="input-box">
              <Typography.Text className="title">نام گزارش: </Typography.Text>
              <Input
                className="input"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Col>
          </Row>
          
          <Row>
            <Col xs={24} className="btn-box">
              <Button
                loading={loading}
                onClick={submit}
                block
                type="primary"
                className="btn"
              >
                ثبت
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
